<template>
  <FormContainer :title="$t('title.user')" :onSubmit="onSubmit">
    <FormItem>
      <b-input v-model="user.firstname" v-validate="'required'" name="firstName" />
    </FormItem>
    <FormItem>
      <b-input v-model="user.lastname" v-validate="'required'" name="lastName" />
    </FormItem>
    <FormItem>
      <div class="field field-body">
        <b-input v-model="user.email" name="email" disabled style="width:100%" />
      </div>
    </FormItem>
    <FormItem>
      <b-select expanded v-model="user.cityId" name="city" v-validate="'required'">
        <option v-for="option in cities" :value="option.id" :key="option.id">{{
          option.name
        }}</option>
      </b-select>
    </FormItem>
    <FormItem>
      <b-select expanded v-model="user.jobId" name="jobInCompany" v-validate="'required'">
        <option v-for="option in jobs" :value="option.id" :key="option.id">{{
          option.name
        }}</option>
      </b-select>
    </FormItem>
    <FormItem>
      <b-select
        expanded
        v-model="selectedSectorGroupId"
        name="companySectorGroup"
        v-validate="'required'"
        @input="onChangeSectorGroup"
      >
        <option v-for="option in sectorGroups" :value="option.id" :key="option.id">{{
          option.name
        }}</option>
      </b-select>
    </FormItem>
    <FormItem>
      <b-select expanded v-model="user.sectorId" name="companySector" v-validate="'required'">
        <option v-for="option in sectors" :value="option.id" :key="option.id">{{
          option.name
        }}</option>
      </b-select>
    </FormItem>
    <b-field>
      <b-radio-button v-model="user.isActive" :native-value="null" type="is-danger">
        <b-icon icon="times"></b-icon>
        <span>{{ $t('title.notVerified') }}</span>
      </b-radio-button>
      <b-radio-button v-model="user.isActive" :native-value="true" type="is-success">
        <b-icon icon="check"></b-icon>
        <span>{{ $t('title.verified') }}</span>
      </b-radio-button>
      <b-radio-button v-model="user.isActive" :native-value="false" type="is-black">
        {{ $t('title.passive') }}
      </b-radio-button>
    </b-field>
  </FormContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../_api/api.service'

export default {
  props: ['id'],
  data() {
    return {
      user: {},
      jobs: [],
      cities: [],
      sectorData: [],
      sectorGroups: [],
      sectors: [],
      selectedSectorGroupId: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'role'])
  },
  mounted() {
    if (!this.id) {
      this.$router.push({ name: 'adminUser' })
    } else {
      this.getSelectList()
      Promise.all([this.getSectors(), this.getUser()]).then(this.loadSectors)
    }
  },
  methods: {
    onChangeSectorGroup(selectedid) {
      this.sectors = this.sectorData.filter(s => s.parentId === selectedid)
    },
    getSelectList() {
      ApiService.query('/select/jobs').then(data => {
        this.jobs = data
      })
      ApiService.query('/select/cities').then(data => {
        this.cities = data
      })
    },
    getSectors() {
      return ApiService.query('/select/sectors').then(data => {
        this.sectorData = data
      })
    },
    getUser() {
      return ApiService.get(`/user/${this.id}`).then(data => {
        this.user = data
      })
    },
    loadSectors() {
      this.sectorGroups = this.sectorData.filter(i => i.parentId == null)
      const userSector = this.sectorData.filter(s => s.id === this.user.sectorId)[0]
      // a user without a sector, or with one no longer listed, picks it here
      if (!userSector) return
      this.selectedSectorGroupId = userSector.parentId
      this.onChangeSectorGroup(this.selectedSectorGroupId)
    },
    onSubmit() {
      ApiService.post('/user', { user: this.user }).then(data => {
        this.user = data
        this.$emit('saved')
        this.$parent.close()
      })
    }
  }
}
</script>
